module.exports = __webpack_public_path__ + "static/media/IMG--061_websize.6d886c0e.jpg";